import { HttpParams } from '@angular/common/http';
import { PageSearch } from '../models/pagination/page-search.model';

export function createPaginationParams(pageSearch: PageSearch | null): HttpParams | undefined {
  if (pageSearch == null) {
    return undefined;
  }

  let params = new HttpParams()
    .set('page', pageSearch.page.toString())
    .set('pageSize', pageSearch.pageSize.toString());

  if (pageSearch.sort != null) {
    params = params.set('sort', pageSearch.sort);
  }

  if (pageSearch.direction != null) {
    params = params.set('direction', pageSearch.direction);
  }

  if (pageSearch.search != null) {
    params = params.set('search', pageSearch.search);
  }

  return params;
}
